import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Componente de prueba para la librería unificada.
 * Simplificado temporalmente mientras se compilan los secondary entry points.
 */
@Component({
  selector: 'app-test-unified-library',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `
    <div class="p-6 max-w-4xl mx-auto">
      <h1 class="text-3xl font-bold mb-6 text-center">🧪 Prueba de Librería Unificada &#64;sura-ui</h1>
      
      <div class="bg-yellow-100 p-4 rounded-lg mb-6">
        <h2 class="text-lg font-semibold text-yellow-800 mb-2">⚠️ Componente Simplificado</h2>
        <p class="text-yellow-700">
          Este componente de prueba está simplificado temporalmente.
          Las importaciones de &#64;sura-ui/atoms, &#64;sura-ui/molecules y &#64;sura-ui/organisms 
          requieren compilar los secondary entry points de la librería.
        </p>
      </div>
      
      <div class="bg-blue-100 p-4 rounded-lg">
        <h2 class="text-lg font-semibold text-blue-800 mb-2">📦 Módulos Disponibles</h2>
        <ul class="text-blue-700 space-y-1">
          <li>✅ &#64;sura-ui/core - Librería principal compilada</li>
          <li>⏳ &#64;sura-ui/atoms - Pendiente compilar entry point</li>
          <li>⏳ &#64;sura-ui/molecules - Pendiente compilar entry point</li>
          <li>⏳ &#64;sura-ui/organisms - Pendiente compilar entry point</li>
        </ul>
      </div>
    </div>
  `
})
export class TestUnifiedLibraryComponent {
  // Componente simplificado - sin dependencias de librerías secundarias
}